<!--
 * @Description: 图片查重列表弹层
 * @Date: 2022-08-23 11:15:47
-->
<template>
  <el-dialog
    center
    title="图片重复关联项目"
    :visible="true"
    :before-close="closeDialog"
    top="7vh"
    width="1500px"
  >
    <base-table :tableColumn="tableColumns" :data="tableData" height="55vh" />
    <base-pagination
      v-model="tablePageQuery"
      :total="tableTotal"
      @input="getTableData"
    />
  </el-dialog>
</template>

<script>
import baseTable from '../../components/Base/baseTable';
import auditRow from '@R/services/audit-row';
import { auditOssStatus } from '@R/api/index';
import { Task } from '@R/api';
import basePagination from '@R/components/Base/basePagination';

const ENUMS = {
  auditStatus: [
    '未提交审核',
    '审核中',
    '审核通过',
    '审核未通过',
    '审核中（重新提交）'
  ]
};
export default {
  name: 'repeatPickureTable',
  components: {
    baseTable,
    basePagination
  },
  props: ['projectId', 'taskId', 'isOpenedByOther'], // isOpenedByOther 是否其他页面跳入或打开。
  data() {
    return {
      tableSearchQuery: {},
      tableData: [],
      tableLoading: false,

      // 当前表格 内容的筛选条件（点击搜索后的条件）
      tableCurrentQuery: {},
      tableTotal: 0,
      tableCurrentPage: 0,
      tablePageQuery: {
        pageSize: 60,
        pageNo: 1
      },
      tableColumns: [
        {
          prop: 'time',
          label: '提交时间',
          width: '150px'
        },
        {
          prop: 'user',
          label: '项目参与人',
          width: '150px'
        },
        {
          prop: 'taskCode',
          label: '任务编码',
          width: '150px'
        },
        {
          // prop: 'pic',
          label: '重复图片',
          width: '500px',
          tooltip: false,
          render: (h, { row }) => {
            let { pic } = row;
            pic = pic ? pic.split(',').filter(item => item) : [];
            let images = pic;
            return h(
              'div',
              !!images &&
                images.map(ele => {
                  return h('el-image', {
                    props: {
                      src: ele,
                      previewSrcList: images
                    },
                    style: {
                      width: '100px',
                      height: '100px',
                      'margin-right': '15px'
                    },
                    on: {
                      click: () => {
                        this.handleClickItem();
                      }
                    }
                  });
                })
            );
          }
        },
        {
          label: '服务商状态',
          prop: 'aspAuditStatus',
          formatter: ({ val }) => {
            return ENUMS['auditStatus'][val];
          }
        },
        {
          label: '平台状态',
          prop: 'ossStatus',
          formatter: ({ val }) => {
            return ENUMS['auditStatus'][val];
          }
        },
        {
          label: '工业状态',
          prop: 'gyStatus',
          formatter: ({ val }) => {
            return ENUMS['auditStatus'][val];
          }
        },
        {
          label: '操作',
          width: '200px',
          fixed: 'right',
          hidden: this.isOpenedByOther, //跳转的无操作
          render: (h, { row }) => {
            const passDisabled =
              +row.aspAuditStatus !== 1 ||
              +row.isItOperable === 0 ||
              +row.isItOperable === 2 ||
              +row.projectId !== +this.projectId; // "isItOperable" : 0 ,// 此条数据是否可以操作 通过 不通过，0否1是 如果不能操作，则此数据只能查看，其余操作都不可
            const noPassDisabled =
              +row.aspAuditStatus !== 1 ||
              +row.isItOperable === 0 ||
              +row.projectId !== +this.projectId; // 此判断是因为运营要图片查重的列表展示其他项目的任务（两个固定项目）
            return (
              <span>
                <el-button
                  type="text"
                  size="mini"
                  disabled={passDisabled}
                  onClick={() => {
                    auditRow({
                      ajax: auditOssStatus,
                      params: {
                        auditStatus: 2,
                        taskId: row.sid,
                        projectId: this.projectId
                      },
                      auditStatus: 2,
                      getList: this.getTableData
                    }).then(() => {
                      this.$emit('parentRefresh');
                    });
                  }}
                >
                  通过
                </el-button>
                <el-button
                  type="text"
                  size="mini"
                  disabled={noPassDisabled}
                  onClick={() => {
                    auditRow({
                      ajax: auditOssStatus,
                      params: {
                        auditStatus: 3,
                        taskId: row.sid,
                        projectId: this.projectId
                      },
                      auditStatus: 3,
                      getList: this.getTableData
                    }).then(() => {
                      this.$emit('parentRefresh');
                    });
                  }}
                >
                  不通过
                </el-button>
              </span>
            );
          }
        }
      ]
    };
  },
  methods: {
    async getTableData() {
      this.tablePageQuery.pageSize = 15;
      const params = {
        taskId: this.taskId,
        projectId: this.projectId,
        ...this.tablePageQuery
      };
      const result = await Task.findSimiForDetail(params);
      const {
        data: { list, total }
      } = result.data;
      this.tableData = list;
      this.tableTotal = total;
    },
    closeDialog() {
      const d = document.getElementsByClassName('el-drawer__wrapper')[0];
      const a = document.getElementsByClassName('el-image-viewer__wrapper');
      if (!a.length && !d) {
        this.$emit('close');
      } else if (d && a.length === 1) {
        this.$emit('close');
      }
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask');
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    }
  },
  watch: {
    tableData: {
      handler(v) {
        const arr = [];
        v.forEach(item => {
          const imgListLength = item.pic
            ? item.pic.split(',').filter(item => item).length
            : 1;
          arr.push(imgListLength);
        });
        //找出图片最多的一项用最多的宽度来作为列宽
        const maxLength = arr.sort()[arr.length - 1];
        this.tableColumns[3].width = maxLength * 130 + 'px';
      }
    },
    deep: true
  },
  created() {
    this.getTableData();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
  display: inline-block;
}
</style>
